import { useEffect, useMemo } from 'react';

import { useLocation } from '@tanstack/react-router';

import { Text } from '@/_components';
import { Alert } from '@/_components/alert';
import type { AttachmentType } from '@/_providers/form-errors-provider';
import { useFormErrorsContext } from '@/_providers/form-errors-provider';

import { Container } from './layout';

const AttachmentErrorLabels: Record<AttachmentType, string> = {
  address: 'Address',
  'phone-number': 'Phone Number',
};

const AttachmentErrorDescription: Record<AttachmentType, string> = {
  address: 'Please verify the address details and try again.',
  'phone-number': 'Please ensure that the number you entered is valid and try again.',
};

export function FormErrors() {
  const { state } = useLocation();

  const isFromNew = !!state?.isFromNew;

  const { errors, resetErrors } = useFormErrorsContext();

  const submissionErrors: string[] = useMemo(() => {
    const allErrorKeys = Object.keys(errors) as AttachmentType[];
    if (allErrorKeys.length === 0) {
      return [];
    }
    return allErrorKeys.reduce((acc, curKey) => {
      const curError = errors[curKey];
      if (!curError) {
        return acc;
      }

      const label = AttachmentErrorLabels[curKey];
      const description = AttachmentErrorDescription[curKey];

      // if (curError.details) {
      //   const errorDetails = Object.values(curError.details)
      //     .flat()
      //     .map((detail) => `${label}: ${detail}`);
      //   return [...acc, ...errorDetails];
      // }
      // return [...acc, `${label}: ${curError.error}`];
      return [...acc, `<b>${label}</b>: ${description}`];
    }, [] as string[]);
  }, [errors]);

  useEffect(
    () => () => {
      resetErrors();
    },
    [resetErrors]
  );

  return (
    isFromNew &&
    submissionErrors.length > 0 && (
      <Container>
        <Alert type="error" className="mb-2 w-full">
          <Text as="h6" className="text-sm">
            We encountered some issues saving following fields:
          </Text>
          <ul className="mt-2 list-disc pl-6">
            {submissionErrors.map((error) => (
              <li className="text-accent-light text-sm" key={error} dangerouslySetInnerHTML={{ __html: error }} />
            ))}
          </ul>
        </Alert>
      </Container>
    )
  );
}
